import { _ } from "extensions/underscore";
import { Highcharts } from "extensions/highcharts";

import { accounting } from "common/utils";
import strings from "common/strings";
import { v2 } from "common/config/api";
import { toHex } from "common/colors";

import { DefaultTypeConfig } from "./default";
import quick_template from "./chargebacks_quick_tmpl.jst";

export const chargebacks = function(options) {
    const opts = {
        by: "count",
        ...options
    };

    const sortRate = (a, b) => (accounting.chargebacks.chargebackRate(a) < accounting.chargebacks.chargebackRate(b) ? -1 : 1);
    
    return new DefaultTypeConfig(opts, {
        urlRoot: "analytics/chargebacks",
        api_endpoint(pivot = "date_time") {
            return v2.chargebacks.byPivot(Array.isArray(pivot) ? pivot : [pivot]);
        },
        totals: ["sales", "chargebacks"].reduce((memo, elt) => {
            ["count", "amount"].forEach((by) => {
                memo[`${elt}_${by}`] = _.partial(accounting[elt].getTotalValue, _, by);
            });
            return memo;
        }, {}),
        quick: {
            chart: false,
            data: {
                summaryTemplate: "custom",
                widgetValueTemplate: quick_template,
                widgetValueTemplateData: {
                    get count() {
                        return DefaultTypeConfig.propGetter("chargebacks", { by: "count" });
                    },
                    get amount() {
                        return DefaultTypeConfig.propGetter("chargebacks", { by: "amount" });
                    }
                }
            },
            reactProps: {
                chartField: "chargebacks_count",
                chartFieldToggle: false,
                chartFieldDataType: "count",
                secondaryField: "chargebacks_amount",
                secondaryFieldToggle: false,
                secondaryFieldDataType: "amount",
                fillColor: Highcharts.Color(toHex("canvas-white")).setOpacity(0.15).get("rgba"),
                color: toHex("canvas-white")
            }
        },
        table: {
            columns: [{
                id: "Actor",
                header: "", // This field is changed by tableView.js
                template(model, pivot) {
                    return DefaultTypeConfig.references.toAlias(model[pivot], pivot);
                },
                sort: "string"
            }, {
                id: strings.dashboard.rate,
                header: strings.dashboard.rate,
                template(model) {
                    return accounting.chargebacks.chargebackRate(model, {
                        humanize: true
                    });
                },
                initialSorting: [sortRate, "desc"],
                css: "value",
                sort: sortRate
            }, {
                id: strings.count,
                header: strings.count,
                template: (model) => accounting.chargebacks.getTotalValue(model, opts.by),
                css: "value",
                sort: (a, b) => (accounting.chargebacks.getTotalValue(a) < accounting.chargebacks.getTotalValue(b) ? -1 : 1)
            }]
        },
        pie: {
            pointValue: `chargebacks_${opts.by}`,
            pointType: opts.by
        },
        doublePivot: {
            by: opts.by,
            dataGetter: _.partial(accounting.chargebacks.getTotalValue, _, opts.by),
            bodyType: "chart",
            tooltip: {
                template: (data) => `<div class="doublePivot-tooltip"><b>${data.network} chargeback code ${data.value}:</b><p>${data.desc}</p></div>`,
                data(o) {
                    return {
                        network: o.primaryPivotAlias,
                        value: o.value,
                        desc: DefaultTypeConfig.references.toAlias(o.value, o.secondaryPivotKey)
                    };
                }
            },
            reactProps: {
                showBadgeInTabs: true,
                countField: "chargebacks_count",
                summaryStyle: 1,
                chart: "bar",
                bodyClass: "barChartCompare"
            }
        }
    });
};
